import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=0d6b38ee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6b38ee')) {
      api.createRecord('0d6b38ee', component.options)
    } else {
      api.reload('0d6b38ee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=0d6b38ee&", function () {
      api.rerender('0d6b38ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-259WRgZTUzYWy/JS/pricehelp.vue"
export default component.exports